const SilverBase = require('silver-base')

/**
 * SilverWdmLog
 * @class 
 */
export class SilverWdmLog extends SilverBase {
  constructor() {
    super()
    if (!window.tv) {
      return
    }

    this.globalData = {}
  }
  /**
   * getName 获取组件名称
   * @memberOf SilverWdmLog.prototype
   * @method getName
   * @return {String} 
   */
  getName() {
    return 'SilverWdmLog'
  }

  _escape(obj) {
    let _obj = {}
    for (let k in obj) {
      if (obj.hasOwnProperty(k)) {
        const value = encodeURIComponent(obj[k])
        k = encodeURIComponent(k)
        _obj[k] = value
      }
    }
    return _obj
  }

  _makeObj(param) {
    let obj = {}
    if (Array.isArray(param)) {
      param.forEach(function(item) {
        if (Array.isArray(item)) {
          obj[item[0]] = item[1]
        } else if (item && typeof item === 'object') {
          for (let k in item) {
            if (item.hasOwnProperty(k)) {
              obj[k] = item[k]
              break
            }
          }
        }
      })
    } else if (param && typeof param === 'object') {
      obj = param
    }
    return obj
  }

  removeGlobal() {
    if (window.tv && window.tv.utRemoveGlobalProperty) {
      for (let k in this.globalData) {
        if (this.globalData.hasOwnProperty(k)) {
          window.tv.utRemoveGlobalProperty(k)
        }
      }
      this.globalData = {}
    }
    return this
  }

  setGlobal(param) {
    this.removeGlobal()
    if (window.tv && window.tv.utSetGlobalProperty) {
      this.globalData = this._escape(this._makeObj(param))
      for (let k in this.globalData) {
        if (this.globalData.hasOwnProperty(k)) {
          window.tv.utSetGlobalProperty(k, this.globalData[k])
        }
      }
    }
    return this
  }

  event(eventId, param) {
    if (window.tv && window.tv.utCustomEventMoreProperties) {
      window.tv.utCustomEventMoreProperties(eventId, JSON.stringify(this._escape(this._makeObj(param))))
    }
    return this
  }
}



// WEBPACK FOOTER //
// ./~/@ali/silver-wdm-log/lib/index.js